import { RootState } from "src/shared/types/src";

export const getTimelineLoading = (state: RootState) => state?.timeline.timelineLoading || false;

export const getTimelinePaginatedLoading = (state: RootState) => state?.timeline.timelinePaginatedLoading || false;

export const getTimelinePagination = (state: RootState) => state?.timeline.timelinePagination;

export const getTimelineCurrentPage = (state: RootState) => state?.timeline?.timelinePagination.currentPage || 1;

export const getTimelineLastPage = (state: RootState) => state?.timeline?.timelinePagination?.lastPage || 1;

export const getTimelineTotalItems = (state: RootState) => state?.timeline?.timelinePagination?.totalItems || 0;

export const getTimelineData = (state: RootState) => state?.timeline.timelineData || [];

export const isTimelineFilterApplied = (state: RootState) => state?.timeline.filters.isFilterApplied || false;

export const getTimelineFilters = (state: RootState) => state?.timeline.filters || {};

export const getTodayDiary = (state: RootState) => state?.timeline?.todaysDiary || [];